import { render, staticRenderFns } from "./message-call-c2c.vue?vue&type=template&id=8bd01056&scoped=true"
import script from "./message-call-c2c.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-call-c2c.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-call-c2c.vue?vue&type=style&index=0&id=8bd01056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd01056",
  null
  
)

export default component.exports